import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ALLOWED_AUDIO_TYPE } from '../../constants/constants';
import { MediaCategory } from '../../enums/enums';
import { MediaSignedUrlModel } from '../../interface/interface';
import { SharedService } from '../../services/shared.service';
import { SharedModule } from '../../shared.module';
import { SkeletonLoaderComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-upload-audio',
  standalone: true,
  imports: [SharedModule, SkeletonLoaderComponent],
  templateUrl: './upload-audio.component.html',
  styleUrl: './upload-audio.component.scss',
})
export class UploadAudioComponent {
  allowedAudioType = ALLOWED_AUDIO_TYPE.join(',');
  audioUploading = false;
  @Output() uploadStart: EventEmitter<void> = new EventEmitter();
  @Output() uploadEnd: EventEmitter<MediaSignedUrlModel | null> =
    new EventEmitter();
  @Output() removeAudio: EventEmitter<void> = new EventEmitter();
  @Input() previewUrl: string = '';

  constructor(
    private sharedService: SharedService,
    private toastr: ToastrService
  ) {}
  onFileSelction = async (event: any) => {
    const file: File = event?.target?.files?.[0];
    if (file) {
      if (!ALLOWED_AUDIO_TYPE.includes(file.type)) {
        this.toastr.error('Please select a valid audio');
        return;
      }
      this.uploadStart.emit();
      this.audioUploading = true;
      this.sharedService
        .getMediaSignedUrl({
          fileName: file.name,
          contentType: file.type,
          category: MediaCategory.AUDIO,
        })
        .subscribe({
          next: (data: MediaSignedUrlModel) => {
            this.sharedService.uploadFile(data.uploadUrl, file).subscribe({
              next: () => {
                this.audioUploading = false;
                this.uploadEnd.emit(data);
              },
              error: (err) => {
                this.uploadEnd.emit(null);
                this.audioUploading = false;
                this.toastr.error(
                  err?.error?.message || err?.message || 'Something went wrong!'
                );
              },
            });
          },
          error: (err) => {
            this.uploadEnd.emit(null);
            this.audioUploading = false;
            this.toastr.error(
              err?.error?.message || err?.message || 'Something went wrong!'
            );
          },
        });
    }
  };
}
